export default __webpack_public_path__ + "static/media/manzil_carousel2.png";